import React from "react";
import {UserMenu, MenuItemLink, Logout, useAuthenticated} from "react-admin";
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';

const CustomUserMenu = (props:any) => {
    useAuthenticated();
    return (
        <UserMenu {...props}>
            <MenuItemLink
                to="/password-change"
                primaryText="Jelszó változtatás"
                leftIcon={<VpnKeyOutlinedIcon />}
            />
            <Logout/>
        </UserMenu>
    );
};

export default CustomUserMenu;
